exports = module.exports = require("./../../../../react-scripts/node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "@media (min-width:800px){.row{clear:both}.pull-right{float:right}.row:after,.row:before{display:block;content:\"\";clear:both}.col-1,.col-2,.col-3,.col-4,.col-5,.col-6,.col-7,.col-8,.col-9,.col-10{float:left}.col-1{width:10%}.col-2{width:20%}.col-3{width:30%}.col-4{width:40%}.col-5{width:50%}.col-6{width:60%}.col-7{width:70%}.col-8{width:80%}.col-9{width:90%}.col-10{width:100%}}.table-row{border:0;border-bottom:1px solid #dfe1e6;padding:16px 0;position:relative}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// /opt/atlassian/pipelines/agent/build/~/react-scripts/~/css-loader!/opt/atlassian/pipelines/agent/build/~/less-loader!./src/css/table.less
// module id = 532
// module chunks = 0